import "./index.scss";

import { Box } from "@mui/material";
import { ReactComponent as UncheckedCircleIcon } from "assets/images/toggle-checkboxes/circle/off-normal.svg";
import { ReactComponent as CheckedCircleIcon } from "assets/images/toggle-checkboxes/circle/on-normal.svg";
import SearchBar from "components/SearchBar";
import { memo, useEffect, useState } from "react";
import HoverVideoPlayer from "react-hover-video-player";

const WorkoutSearchableList = (props) => {
  const { options, selectedEntries, callback } = props;
  const [searchStr, setSearchStr] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState<any[]>(null);

  useEffect(() => {
    let processedOptions = options.map((e) => {
      return { ...e, ...{ checked: selectedEntries?.includes(e.id) ?? false } };
    });
    setFilterOptions(processedOptions);
  }, [options, selectedEntries]);

  useEffect(() => {
    if (callback && selectedValues) {
      //Return the selected entries to callback
      callback(selectedValues);
    }
  }, [selectedValues]);

  const handleSearch = (str: string) => {
    setFilterOptions([
      ...options.filter((x) => x.title?.toLowerCase().includes(str.toLowerCase())),
    ]);
    setSearchStr(str);
  };

  const handleSelectEntry = (id: number) => {
    let newFilterOptions = filterOptions.map((e) => {
      if (e.id === id) {
        e.checked = !e.checked;
        return e;
      }
      return e;
    });
    setSelectedValues([...newFilterOptions.filter((x) => x.checked)]);
    setFilterOptions(newFilterOptions);
  };

  return (
    <Box className={`searchable-list-container`}>
      <Box className="header">
        <SearchBar className="search-bar" value={searchStr} onSearch={handleSearch} />
      </Box>
      <Box className="list">
        {filterOptions.map((item, index) => (
          <Box className="workoutEntry" key={`workoutEntry-${index}`}>
            <div className="video">
              <HoverVideoPlayer
                videoSrc={item.video}
                restartOnPaused
                loadingOverlay={
                  <div className="loading-overlay">
                    <div className="loading-spinner" />
                  </div>
                }
              />
            </div>
            <div className="details">
              <div className="title" onClick={() => handleSelectEntry(item.id)}>
                <span>{item.title}</span>
                <div className="check">
                  {item.checked ? <CheckedCircleIcon /> : <UncheckedCircleIcon />}
                </div>
              </div>
              <div className="description" onClick={() => handleSelectEntry(item.id)}>
                {item.instructions}
              </div>
            </div>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default memo(WorkoutSearchableList);
